(function($) {
    var $fn = $(".comp_rooms_slider"),
        $slider = $fn.find("[data-slider]"),
        $slider_autoplay = $slider.data("autoplay");

    var $autoplay = true;
    if ($slider_autoplay === "0" || $slider_autoplay === "") {
        $autoplay = false;
    }

    if ($slider.find(".col").length > 3) {
        $slider.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            speed: 500,
            autoplay: $autoplay,
            pauseOnHover: true,
            autoplaySpeed: $slider_autoplay,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev icon--chevron-left"></button>',
            nextArrow: '<button type="button" class="slick-next icon--chevron-right"></button>',
            dots: false,
            responsive: [
                {
                    breakpoint: 959,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    $(".comp_conference_slider").each(function() {
        var $conference = $(this),
            $conference_slider = $conference.find("[data-conference-slider]"),
            $conference_slider_autoplay = $conference_slider.data("autoplay");

        var $conference_autoplay = true;
        if ($conference_slider_autoplay === "0" || $conference_slider_autoplay === "" || $conference_slider_autoplay === 0) {
            $conference_autoplay = false;
        }

        if ($conference_slider.find(".col").length > 1) {
            $conference_slider.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                autoplay: $conference_autoplay,
                pauseOnHover: true,
                autoplaySpeed: $conference_slider_autoplay,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev icon--chevron-left"></button>',
                nextArrow: '<button type="button" class="slick-next icon--chevron-right"></button>',
                dots: false
            });
        }
    });
})(jQuery);
